





































import {Vue, Component, PropSync, Watch} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {TemplateMaskingItem} from "@/store/settings/templates/types";

@Component({})
export default class MaskingTemplate extends Vue {
  @PropSync("template") templateObject!: TemplateMaskingItem;
  @Getter("systemSettings") systemSettings: any;
  @Action("getSystemSettings") actionGetSystemSettings: any;

  created() {
    this.actionGetSystemSettings();
  }

  get systemMaskedVariables(): string[] {
    const text = this.systemSettings.find((e: any) => e.name === 'MASKED_SYSTEM_VARIABLES')?.value;
    console.log(text);
    if (text) {
      const matches = text.match(/\$(\w+)/g);
      return matches ? matches.map((m: string) => m.slice(1)) : [];
    } else {
      return [];
    }

  }

  get variablesFromText(): string[] {
    const contentSources = [
      this.templateObject?.message,
      this.templateObject?.content,
      this.templateObject?.subject,
      this.templateObject?.title,
      this.templateObject?.vk_message,
      this.templateObject?.ok_message
    ]
        .filter(Boolean) as string[];
    const all = new Set<string>();
    const sys = new Set<string>(this.systemMaskedVariables);
    contentSources.forEach(txt => {
      const matches = txt.match(/\$(\$?\w+)/g);
      matches?.forEach(m => {
        const name = m.slice(1);
        if (!sys.has(name)) all.add(name);
      });
    });
    return Array.from(all);
  }

  @Watch('templateObject.masked_variables', { deep: true })
  onMaskedVariablesChange(val?: string[]) {
    if (!Array.isArray(val)) return;
    const system = new Set<string>(this.systemMaskedVariables);
    const filtered = val.filter(v => !system.has(v));
    if (filtered.length !== val.length) this.templateObject.masked_variables = filtered;
  }
}
